import { repository, baseURL } from "@/api/base"

export default {
  async getFile(id) {
    const { data } = await repository.get(baseURL + '/file/' + id, { responseType: "arraybuffer" })
    return data
  },

  getFileLink(id) {
    return `${baseURL}/file/${id}`
  },

  async getFiles(refId, refClassName) {
    const { data } = await repository.get(baseURL + '/file/findAllByRef?refId=' + refId + "&refClassName=" + refClassName)
    return data
  },

  async postFiles(file, refId, refClassName) {
    const formData = new FormData()
    formData.append('files', file)
    const { data } = await repository.post(baseURL + '/file?refId=' + refId + "&refClassName=" + refClassName, formData)
    return data
  },

  async deleteFile(id) {
    const data  = await repository.delete(baseURL + '/file/' + id)
    return data
  },

  async findAllFilesByApplicationId(applicationId) {
    const { data } = await repository.get(baseURL + `/file/findAllFilesByApplicationId/${applicationId}`)
    return data
  },
}
